import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _792be91a = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _4e9b8902 = () => interopDefault(import('..\\pages\\reimbursement\\index.vue' /* webpackChunkName: "pages_reimbursement_index" */))
const _24963b74 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _17b7df69 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _9ca10c5c = () => interopDefault(import('..\\pages\\enroll\\eligibility.vue' /* webpackChunkName: "pages_enroll_eligibility" */))
const _081842be = () => interopDefault(import('..\\pages\\enroll\\insurance-information.vue' /* webpackChunkName: "pages_enroll_insurance-information" */))
const _785a6829 = () => interopDefault(import('..\\pages\\enroll\\patient-information.vue' /* webpackChunkName: "pages_enroll_patient-information" */))
const _ad274b62 = () => interopDefault(import('..\\pages\\enroll\\prescriber-information.vue' /* webpackChunkName: "pages_enroll_prescriber-information" */))
const _401349c8 = () => interopDefault(import('..\\pages\\enroll\\success.vue' /* webpackChunkName: "pages_enroll_success" */))
const _e760c058 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _e7449156 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _e70c3352 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _e6f00450 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _7d9449d6 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _7fa3ed3d = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _792be91a,
    name: "error"
  }, {
    path: "/reimbursement",
    component: _4e9b8902,
    name: "reimbursement"
  }, {
    path: "/rejection",
    component: _24963b74,
    name: "rejection"
  }, {
    path: "/unlock",
    component: _17b7df69,
    name: "unlock"
  }, {
    path: "/enroll/eligibility",
    component: _9ca10c5c,
    name: "enroll-eligibility"
  }, {
    path: "/enroll/insurance-information",
    component: _081842be,
    name: "enroll-insurance-information"
  }, {
    path: "/enroll/patient-information",
    component: _785a6829,
    name: "enroll-patient-information"
  }, {
    path: "/enroll/prescriber-information",
    component: _ad274b62,
    name: "enroll-prescriber-information"
  }, {
    path: "/enroll/success",
    component: _401349c8,
    name: "enroll-success"
  }, {
    path: "/errors/400",
    component: _e760c058,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _e7449156,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _e70c3352,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _e6f00450,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _7d9449d6,
    name: "errors-500"
  }, {
    path: "/",
    component: _7fa3ed3d,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
